import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const verifySignModal: ThemeUICSSObject = {
  minWidth: '550px',
  display: 'flex',
  flexDirection: 'column',
  gap: 3,

  '&.verifysign__container': {
    outline: 'none!important',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    background: 'palette.background.paper',
    padding: 3,
    borderRadius: 'default',
    border: '1px solid',
    borderColor: 'palette.gray.800',

    '.verifysign__table_container': {
      width: '100%',
      maxHeight: '310px',
      overflowY: 'auto',
      display: 'block',
      boxSizing: 'border-box',
      position: 'relative',
      table: {
        borderCollapse: 'collapse',
        tableLayout: 'fixed',
        boxSizing: 'border-box',
        td: { borderLeft: 0, borderRight: 0 },

        'tr:last-child td:first-child': {
          borderBottomLeftRadius: 'default',
        },
        'tr:last-child td:last-child': {
          borderBottomRightRadius: 'default',
        },
      },

      th: {
        position: 'sticky',
        top: 0,
        backgroundColor: 'palette.background.paper',
        zIndex: 2,
        border: 'none',
        borderBottom: '1px solid #ccc',
        padding: '8px',
        textAlign: 'left',
      },

      'th:first-of-type': {
        width: '200px',
      },
      tbody: {
        '.selected': {
          background: 'palette.gray.900',
        },

        'tr > td:first-of-type': {
          width: '20%',
        },
        td: {
          padding: 3,
          borderBottom: '1px solid #ececec',
          verticalAlign: 'top',
        },
        '.iconButton': {
          border: 'none',
        },
      },
    },
  },
};

export default verifySignModal;
